var map = {
	"./account.svg": 1069,
	"./apple.svg": 1070,
	"./carzi-loading.svg": 1071,
	"./carzi-logo.svg": 1072,
	"./carzi_coins.svg": 1073,
	"./cash.svg": 1074,
	"./checkmark.svg": 1075,
	"./circle.svg": 1076,
	"./de.svg": 1077,
	"./en.svg": 1078,
	"./epayments.svg": 1079,
	"./export.svg": 1080,
	"./fr.svg": 1081,
	"./google.svg": 1082,
	"./group_pm.svg": 1083,
	"./it.svg": 1084,
	"./marker.svg": 1085,
	"./mastercard.svg": 1086,
	"./pin_logo.svg": 1087,
	"./pin_logo_active.svg": 1088,
	"./pin_photo_act.svg": 1089,
	"./pin_photo_pas.svg": 1090,
	"./place_marker.svg": 1091,
	"./place_marker_active.svg": 1092,
	"./rating-good.svg": 1093,
	"./rating-insufficient.svg": 1094,
	"./rating-not-covered.svg": 1095,
	"./rating-ready.svg": 1096,
	"./twint.svg": 1097,
	"./visa.svg": 1098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1068;